import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

import styled from '@emotion/styled';

import Stars from '../../../components/Badge/Stars';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import UserThisProfileIcon from '../../../components/Icons/UserThisProfileIcon';
import PageLayout from '../../../components/Layout/PageLayout';
import Page from '../../../components/Page/Page';
import Table from '../../../components/Table/Table';
import ActionRow from '../../../components/Table/TableAccessories/ActionRow';
import {
  COMPANY_INSIGHTS,
  COMPANY_INSIGHTS_DRIVER_LIST,
  COMPANY_INSIGHTS_DRIVER_LIST_PAST_COMPANIES,
} from '../../../routes/routeConstants';

const DriverHistoryDriverList = () => {
  const navigate = useNavigate();
  const [pathArr, setPathArr] = useState<Record<string, string>[]>([]);

  useEffect(() => {
    setPathArr(() => [
      {
        name: `Driver History`,
        link: `/${COMPANY_INSIGHTS}`,
      },
      {
        name: `Pacific Stereo`,
        link: `/${COMPANY_INSIGHTS_DRIVER_LIST}`,
      },
    ]);
    // eslint-disable-next-line
  }, []);

  return (
    <Page title='Logirate | Driver History Driver List'>
      <PageLayout>
        <BreadCrumbs pathData={pathArr as any} />
        <Container>
          <Table
            // border
            tableTitle='DRIVER LIST'
            tableFilterBoxFeatures={{
              showSearchBox: true,
              searchBoxPlaceholder: 'Search Driver Name',
            }}
            tableHeader={{
              'Driver Name': 'driverName',
              'Time at Company': 'timeAtCompany',
              'Driver Rating': 'driverRating',
            }}
            tableDataSourceUrl='authentication-service/ba/v1/company/users/warehouse'
            cellsCustomComp={{
              driverRating: <Stars dataKey='driverRating' />,
            }}
            moreOptionsComponents={[
              <ActionRow
                key='View driver history'
                label='View driver history'
                width='195px'
                icon={<UserThisProfileIcon />}
                actionFn={async (data: any) =>
                  navigate(`/${COMPANY_INSIGHTS_DRIVER_LIST_PAST_COMPANIES}`)
                }
              />,
            ]}
            // mobileCellComp={<UserProfileManagementCell />}
            // showPaginationControl={false}
          />
        </Container>
      </PageLayout>
    </Page>
  );
};

export default DriverHistoryDriverList;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
